<ng-container *ngIf="patient">
  <div class="row" [class.disabled]="disabled" (click)="!disabled ? selectPatient() : null">
    <div class="col"><span class="name">{{ patient.name }}</span><span class="age">{{ patient.age | trim }}</span></div>
    <div class="col">{{ patient.species }} ({{ patient.breed || 'Unknown' }})</div>
  </div>
</ng-container>
